import { useTranslation } from 'react-i18next';
import { BillableMaterial } from '../types';
import { Box, Divider, Stack, Typography } from '@mui/material';

type BillableMaterialTooltipContentProps = {
  material: BillableMaterial;
};

export default function BillableMaterialTooltipContent({ material }: BillableMaterialTooltipContentProps) {
  const { t } = useTranslation();
  return (
    <Stack direction='column' spacing={1} flex={1} width='20em'>
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
        {material.name}
      </Typography>
      <Divider />
      {material.conditionSets.map((cs, csIndex) => (
        <Box key={cs.id}>
          {csIndex > 0 && (
            <Divider>
              <Typography
                variant='body2'
                sx={{ fontWeight: 'bold', my: 1, textAlign: 'center', textTransform: 'uppercase' }}
              >
                {t('billableMaterial.or')}
              </Typography>
            </Divider>
          )}
          <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 0.5 }}>
            {t('administration.billableMaterials.rule', 'Regel')} {csIndex + 1}:
          </Typography>
          <Stack spacing={0.5} sx={{ pl: 2 }}>
            {cs.conditions.map((condition, conditionIndex) => (
              <Typography key={conditionIndex} variant='body2'>
                — {t(`billableMaterial.tooltip.${condition.type}`, { ...condition })}
              </Typography>
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
